var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 8,
    y: 12,
    width: 8,
    height: 0.01,
    fill: "url(#paint0_linear_306_1321)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "url(#paint1_linear_306_1321)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_306_1321",
    x1: 16,
    y1: 12.0051,
    x2: 8,
    y2: 12.0052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_306_1321",
    x1: 22,
    y1: 12.1754,
    x2: 2,
    y2: 12.1754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#DBDBDB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.79f9dcbc7284fc0cdb9cba0a4a864baa.svg";
export { ForwardRef as ReactComponent };